import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/hooks/useLanguage';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

interface ReferralStepProps {
  form: UseFormReturn<any>;
}

const ReferralStep = ({ form }: ReferralStepProps) => {
  const { t } = useLanguage();
  const referredBy = form.watch('referredBy');

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2">{t('booking.referredBy')}</h3>
        <p className="text-muted-foreground">Help us understand how you found our services</p>
      </div>

      <FormField
        control={form.control}
        name="referredBy"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('booking.referredBy')} *</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select an option" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Search">{t('booking.search')}</SelectItem>
                <SelectItem value="Google Ads">{t('booking.googleAds')}</SelectItem>
                <SelectItem value="Facebook">{t('booking.facebook')}</SelectItem>
                <SelectItem value="Instagram">{t('booking.instagram')}</SelectItem>
                <SelectItem value="Blog">{t('booking.blog')}</SelectItem>
                <SelectItem value="Other">{t('booking.other')}</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {referredBy === 'Other' && (
        <FormField
          control={form.control}
          name="referredOther"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('booking.referredOther')}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Please specify" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
};

export default ReferralStep;
